(function(){
    angular
        .module('app')
        .directive('ngTodecimal', ngTodecimal);

        ngTodecimal.$inject = ['$timeout'];
        function ngTodecimal($timeout){
            return {
	            require: 'ngModel',

	            scope: { decimales : "=" },
	            link: function(scope, element, attrs, ngModel) {
					console.log("numdecimales",scope.numdecimales);
	            	element.on('keydown', function (event) {  
		                var $input = $(this);  
		                var value = $input.val();  

		                value = value.replace(/[^0-9,.-]/g, '')  
		                $input.val(value);
		                //console.log(event.which);  
		                if (event.which == 64 || event.which == 16) {  
		                    // to allow numbers  
		                    return false;  
		                } else if (event.which >= 48 && event.which <= 57) {  
		                    // to allow numbers  
		                    return true;  
		                } else if (event.which >= 96 && event.which <= 105) {  
		                    // to allow numpad number  
		                    return true;  
		                } else if ([8, 13, 27, 37, 38, 39, 40,109,189].indexOf(event.which) > -1) {  
		                    // to allow backspace, enter, escape, arrows,minus
		                    return true;  
		                }else if ([188,190].indexOf(event.which) > -1) {  
		                    // to allow backspace, enter, escape, arrows  
		                    return true;  
		                } else {  
		                    event.preventDefault();  
		                    // to stop others  
		                    //alert("Sorry Only Numbers Allowed");  
		                    return false;  
		                }  
		            });  
					function comprobarCampo(){
						console.log("compro");
						var $input = $(element);  
		            	var valor = $input.val();  
		            		//console.log("valor",valor);
							if(valor){
		            		console.log(valor);

		            		if(angular.isDefined(scope.decimales)){
					      		ngModel.$setViewValue(parseFloat(valor).toFixed(scope.decimales));
		            		}else{
					      		ngModel.$setViewValue(parseFloat(valor).toFixed(2));
					      	}
				      		ngModel.$render();
				      	}
					}
		            element.on('blur', function (event) {  
		                comprobarCampo();
		            })
					comprobarCampo();
	            	ngModel.$parsers.push(function (inputValue) {
						//console.log("parser");
		                if (inputValue == null)
		                    return ''
			      		var valor = inputValue.replace(',', '.');
			      		ngModel.$setViewValue(valor);
			      		ngModel.$render();
		                return valor;
		            });
					scope.primeraVez = false;
					scope.$watch(function(newValue,oldValue) {
						if(newValue!=oldValue && !scope.primeraVez){
							comprobarCampo();
							scope.primeraVez = true;
						}
						//console.log("newvalue", newValue);
						//console.log("oldValue", oldValue);
					},true);
			      
			      /*ngModel.$formatters.push(function(value) {
	            	console.log("tocecimal2");
			      	    return value ? parseFloat(value).toFixed(2).toString().replace(',', '.') : null;
			      });*/
				}
        	}
        }
})();